export const LOCAL_STORAGE_KEYS = {
  USER_DISTRIBUTOR_ID: "user-distributor-id",
  USER_DISTRIBUTOR_NAME: "user-distributor-name",
  USER_NAME: "user-name",
};
